<template>
  <v-container fill-height fluid>
    <v-row align="center" justify="center">
      <v-col cols="5">
        <v-card class="elevation-12">
          <v-card-text
            ><p class="text-center">Heureux de vous compter parmi les nouveaux inscrits ! 🙂</p>
            <p class="text-center">
              Un mail vous a été envoyé dans le but de valider votre profil.
            </p>
            <p class="text-center">
              Une fois les documents reçus, votre compte sera activé dans un délai moyen de 24h.
            </p>
            <p class="text-right font-weight-bold">
              L'équipe R'Cog
            </p></v-card-text
          >
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "SuccessfullRegistration",
  data: () => ({})
};
</script>
